import { Component, Inject, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'privacy-snack-bar',
  templateUrl: 'privacy-snack-bar.component.html',
  styleUrls: ["./privacy-snack-bar.component.scss"]
})
export class PrivacySnackBar {
  @Output() triggerGoogleLogin: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() {}

  doAgree() {
    this.triggerGoogleLogin.emit(true);
  }

  doDismiss() {
    this.triggerGoogleLogin.emit(false);
  }
}
